import {WorkrequestLndNwDetails} from './workrequest-lnd-nw-details';
import {LndBase} from '../lnd-w-form/lnd-base';
import {WorkrequestLndBaseDetails} from '../lnd-w-form/workrequest-lnd-base-details';

export class LndNw extends LndBase {

  constructor() {
    super();
    this.workrequestDetails = new WorkrequestLndNwDetails();
    this.applicationType = 'LNDNW';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-nw-form/lnd-nw.ts